<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      :placeholder="placeholder"
      @change="handleChange"
      :multiple="multiple"
      filterable
      :size="size"
    >
      <el-option
        v-for="item in listBackup"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import cardUpdateTypes from '@/enums/cardUpdateTypes';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    clearable: Boolean,
    multiple: Boolean,
    size: {
      type: String,
      default: 'medium',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择操作分类',
    },
    disabled: Boolean,
  },
  data: () => ({
    valueBackup: 0,
    listBackup: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = value;
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    this.valueBackup = this.multiple ? (this.value || []) : this.value;
    this.listBackup = cardUpdateTypes;
  },
};
</script>
